/**
 * Matomo analytics loader — gated by the "statistics" consent category.
 *
 * Nothing runs until the visitor grants statistics cookies via the consent
 * banner. The Matomo snippet is reproduced verbatim from the official tag,
 * only wrapped so it executes after consent.
 */

import { whenConsent } from '@/Lib/consent';

const MATOMO_URL = 'https://matomo.p42.studio/';
const MATOMO_SITE_ID = '11';

/** Inject the Matomo tracker once the visitor has granted statistics consent. */
export function initMatomo(): () => void {
    return whenConsent('statistics', () => {
        if (typeof window === 'undefined' || typeof document === 'undefined') return;

        const w = window as unknown as { _paq?: unknown[] };
        w._paq = w._paq || [];

        const _paq = w._paq;
        _paq.push(['setDocumentTitle', `${document.domain}/${document.title}`]);
        _paq.push(['setCookieDomain', '*.fleischerei-tuitjer.de']);
        _paq.push(['setDomains', ['*.fleischerei-tuitjer.de']]);
        _paq.push(['trackPageView']);
        _paq.push(['enableLinkTracking']);

        _paq.push(['setTrackerUrl', `${MATOMO_URL}matomo.php`]);
        _paq.push(['setSiteId', MATOMO_SITE_ID]);

        const g = document.createElement('script');
        const s = document.getElementsByTagName('script')[0];
        g.async = true;
        g.src = `${MATOMO_URL}matomo.js`;
        s.parentNode?.insertBefore(g, s);
    });
}